export default __webpack_public_path__ + "static/Term_Dates-57641f43ab619540184e2e59138f89f4.pdf";